<template>
  <div>
    <div v-if="page.top_video || page.top_image" class="main-video" ref="video">
      <img v-if="page.top_image" :src="page.top_image.url" alt="Forestal" class="abs">
      <video v-if="page.top_video" :src="page.top_video.url" :poster="page.top_image.url" class="abs" autoplay muted preload loop playsinline>
        <!-- <source src="https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
          type="video/mp4" /> -->
      </video>
      <div class="wrapper textBox" v-if="page.content.description || page.content.link_title">
        <div class="text" v-if="page.content.description">{{ page.content.description }}</div>
        <a :href="page.content.link_url" class="link" v-if="page.content.link_title">{{ page.content.link_title }}</a>
      </div>
    </div>
    <div class="main-page">
      <div class="product-news" v-if="page.content && page.content.manuals && page.content.manuals.length > 0">
        <div class="wrapper">
          <flickity :options="topFlickityOptions" class="product-news-wrap">
            <a
              :href="item.document.url"
              data-fancybox="manuals"
              target="_blank"
              class="product-news-card"
              v-for="(item, index) in page.content.manuals"
              :key="index"
            >
              <div class="title">{{ item.title }}</div>
              <img :src="item.image.url" alt="" class="abs br-32"/>
            </a>
          </flickity>
        </div>
      </div>
      <div v-if="page.content && page.content.models && page.content.models.length > 0" class="models wrapper mb-200">
        <h2 class="models-title">Models</h2>
        <div class="models-list">
          <div class="card br-32"
               v-for="(model, index) in page.content.models"
               :key="index">
            <div class="card-wrap">
              <div class="info-box">
                <div class="title"
                     :class="modelClass(model)">
                  {{ model.title }}
                </div>
                <div class="features">{{ model.description }}</div>
              </div>
              <div class="btn-box">
                <div class="btn-wrap">
                  <a v-if="model.coming_soon" :href="`/${lang}/products/${model.model}`">Coming Soon</a>
                  <a v-if="!model.coming_soon" :href="modelLink(model)">Show more</a>
                  <span v-if="!model.coming_soon && model.purchasable" class="plank"></span>
                  <a v-if="!model.coming_soon && model.purchasable" :href="`/${lang}/choose/${model.model}`"
                     class="bold">Order</a>
                  <div class="abs btn-wrap-abs"></div>
                </div>
              </div>
            </div>
            <img :src="model.image.url" alt="" class="abs br-32"/>
          </div>
        </div>
      </div>

      <div class="news start-news mb-200" v-if="news && news.length > 0">
        <div class="news-header wrapper">
          <div class="news-header-left">
            <h2 class="title mt-0">News</h2>
            <div class="info">
              Everything you need to read about us. The latest Forestal’s releases, products, limited offers, events and
              news.
            </div>
          </div>
          <div class="news-header-right">
            <a :href="`/${lang}/news`" class="btn-shadow-arr"> More news <span class="ic"></span> </a>
          </div>
        </div>

        <div class="flickity-wrap">
          <div class="wrapper">
            <flickity :options="newsFlickityOptions" class="start-news_list">
              <a
                v-for="(n, index) in news"
                :key="`news-${n.id}`"
                :class="{ firstItem: index === 0 }"
                :href="n.slug ? `/${lang}/post/${n.slug}` : null"
                class="news-card__item"
              >
                <div class="news-card__image">
                  <img v-if="n.images[0]" :alt="n.title" :src="getStorageLink(n.images[0].image)"/>
                </div>
                <div class="news-card__text">
                  <h4>
                    {{ n.title }}
                  </h4>
                  <p class="descP">{{ n.desc }}</p>
                </div>
              </a>
            </flickity>
          </div>
        </div>

        <div class="news-header-right wrapper">
          <a :href="`/${lang}/news`" class="btn-shadow-arr"> More news <span class="ic"></span> </a>
        </div>
      </div>

      <div class="wrapper mb-200">
        <div class="banner-shadow grid-col grid-cols-8 gap-5">
          <div class="img-box">
            <picture>
              <source srcset="/assets/images/main/dealers-banner-sm.jpg" media="(max-width: 575px)"/>
              <img class="w-full block" src="/assets/images/main/dealers-banner-xl.jpg" alt=""/>
            </picture>
          </div>
          <div class="text-box">
            <p class="caption">Dealer finder</p>
            <div class="info">Search for your nearest Forestal dealer by clicking here.</div>
            <a :href="`/${lang}/page/dealers`" class="link">Find dealer</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Flickity from "vue-flickity";
import {mapGetters} from "vuex";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default {
  name: "IndexPageComponent",
  props: ["lang", "trans", "value"],
  components: {Flickity},
  computed: {
    ...mapGetters(["storage"]),
  },
  data() {
    return {
      page: {
        top_video: null,
        content: {
          models: [],
          manuals: [],
        },
      },
      news: [],
      newsFlickityOptions: {
        draggable: true,
        pageDots: false,
        prevNextButtons: false,
        imagesLoaded: false,
        adaptiveHeight: false,
        freeScroll: true,
        contain: true,
        percentPosition: false,
        cellAlign: 'left',
      },
      topFlickityOptions: {
        draggable: true,
        pageDots: true,
        prevNextButtons: false,
        imagesLoaded: false,
        adaptiveHeight: false,
        freeScroll: true,
        contain: true,
        groupCells: true,
      },
    };
  },
  mounted() {
    if (this.value === undefined) {
      axios
        .get("/api/index-page")
        .then((response) => {
          this.page = response.data;
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      this.page = this.value;
    }

    axios
      .get("/api/getNews?limit=15")
      .then((response) => {
        this.news = response.data.en || [];
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    isEBike(title) {
      return title.toLowerCase().replace(/\s+/g, '').startsWith("e-")
    },
    modelClass(model) {
      return {'e-first': this.isEBike(model.title)}
    },
    modelLink(model) {
      let slug = model.model

      if (slug === 'e-cygnus' || slug === 'e-siryon' || slug === 'e-hydra' || slug === 'e-cyon') {
        slug = slug.replace("e-", "")
      } else if (slug === "cygnus" || slug === "siryon") {
        slug += "/muscular"
      }

      return `/${this.lang}/products/${slug}`
    },
    getStorageLink(path) {
      return this.storage + path;
    },
  },
  watch: {
    "page.top_video"(value) {
      if (value === null) {
        return;
      }

      var header = document.querySelector("header.header");

      this.$nextTick(() => {
        ScrollTrigger.create({
          trigger: this.$refs.video,
          onToggle: (self) => {
            header.classList.toggle("bg-transparent", self.isActive);
          },
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.news-card__item {
  //margin: 0 20px;
  margin-bottom: 15px !important;
}

.flickity-wrap {
  margin-bottom: -15px;
}

.news-card__text a {
  color: #000;
  text-decoration: none;
}

.news-card__text a:visited {
  color: #000;
  text-decoration: none;
}

.main-page {
  .product-news {
    .product-news-wrap {
      &.flickity-enabled {
        display: block;
        overflow: hidden;

        .product-news-card {
          text-decoration: none;

          @media screen and (max-width: 1279px) {
            width: 50%;
          }

          @media screen and (max-width: 768px) {
            width: 100%;
          }
        }
      }
    }
  }
}

.product-news-wrap::v-deep {
  .flickity-page-dots {
    bottom: -60px;

    .dot {
      width: 8px;
      height: 8px;
      background-color: #c4c4c4;
      margin: 0 10px;

      &:after {
        width: 8px;
        height: 8px;
      }
    }
  }
}
</style>
